import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Image,
  Linking,
} from "react-native";
import {
  Ionicons,
  FontAwesome5,
  Feather,
  MaterialIcons,
  FontAwesome,
} from "@expo/vector-icons";
import { Authen, tokenState } from "../reducer/reducer/reducer/Atom";
import { useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";
import { getActionUser } from "../action/actionlogin";
const { width, height } = Dimensions.get("window");

export default function Drawer({ navigation }) {
  const [auth, setAuth] = useRecoilState(Authen);
  const token = useRecoilValue(tokenState);
  const rmToken = useResetRecoilState(tokenState);
  const [isSuperAdmin, setIsSuperAdmin] = useState(true);

  async function getAdminInformation() {
    const results = await getActionUser(token)
    if (results.status == 200) {
      setIsSuperAdmin(results.data.data.event_id === null);

      return
    }

    navigation.navigate("Login");
  }

  useEffect(() => {
    getAdminInformation();
  }, []);

  return (
    <View style={styles.container}>
      <Image
        style={styles.icon}
        source={require("../image/logo_sosorun_icontop.png")}
      />
      {isSuperAdmin && <TouchableOpacity
        onPress={() => navigation.navigate("Home")}
        style={[styles.touch, { marginTop: 20 }]}
      >
        <Feather
          name="home"
          size={15}
          color="#FCC81D"
          style={{ alignSelf: "center" }}
        />
        <Text style={styles.text}>HOME</Text>
      </TouchableOpacity>}
      {isSuperAdmin && <TouchableOpacity
        onPress={() => navigation.navigate("AddBonus")}
        style={styles.touch}
      >
        <Ionicons
          name="today-sharp"
          size={15}
          color="#F53C56"
          style={{ alignSelf: "center" }}
        />
        <Text style={styles.text}>DAILY BONUS</Text>
      </TouchableOpacity>}
      {isSuperAdmin && <TouchableOpacity
        onPress={() => navigation.navigate("Banner")}
        style={styles.touch}
      >
        <FontAwesome5
          name="adversal"
          size={15}
          color="#11CDEF"
          style={{ alignSelf: "center" }}
        />
        <Text style={styles.text}>BANNER</Text>
      </TouchableOpacity>}
      <TouchableOpacity
        onPress={() => navigation.navigate("HomeEvent")}
        style={styles.touch}
      >
        <Feather
          name="file-text"
          size={15}
          color="#FB6340"
          style={{ alignSelf: "center" }}
        />
        <Text style={styles.text}>EVENT</Text>
      </TouchableOpacity>
      {isSuperAdmin && <TouchableOpacity
        onPress={() => navigation.navigate("Lvlist")}
        style={styles.touch}
      >
        <FontAwesome
          name="toggle-up"
          size={15}
          color="black"
          style={{ alignSelf: "center" }}
        />

        <Text style={styles.text}>LEVEL</Text>
      </TouchableOpacity>}
      {isSuperAdmin && <TouchableOpacity
        onPress={() => navigation.navigate("FreePoint")}
        style={styles.touch}
      >
        <FontAwesome5
          name="coins"
          size={15}
          color="#172B4D"
          style={{ alignSelf: "center" }}
        />
        <Text style={styles.text}>FREE POINT</Text>
      </TouchableOpacity>}
      {isSuperAdmin && <TouchableOpacity
        onPress={() => navigation.navigate("DisCount")}
        style={styles.touch}
      >
        <MaterialIcons
          name="card-giftcard"
          size={15}
          color="#2DCE98"
          style={{ alignSelf: "center" }}
        />
        <Text style={styles.text}>DISCOUNT</Text>
      </TouchableOpacity>}
      {isSuperAdmin && <TouchableOpacity
        onPress={() => navigation.navigate("HomeEventCoupon")}
        style={styles.touch}
      >
        <MaterialIcons
          name="card-giftcard"
          size={15}
          color="#2DCE98"
          style={{ alignSelf: "center" }}
        />
        <Text style={styles.text}>COUPON</Text>
      </TouchableOpacity>}
      {isSuperAdmin && <TouchableOpacity
        onPress={() => navigation.navigate("User")}
        style={styles.touch}
      >
        <FontAwesome5
          name="user-alt"
          size={15}
          color="#8898AA"
          style={{ alignSelf: "center" }}
        />
        <Text style={styles.text}>USER</Text>
      </TouchableOpacity>}
      {isSuperAdmin && <TouchableOpacity
        onPress={() => navigation.navigate("Eventrank")}
        style={styles.touch}
      >
        <FontAwesome5
          name="chart-line"
          size={15}
          color="#F53C56"
          style={{ alignSelf: "center" }}
        />
        <Text style={styles.text}>RANK</Text>
      </TouchableOpacity>}
      {isSuperAdmin && <TouchableOpacity
        onPress={() => navigation.navigate("Report")}
        style={styles.touch}
      >
        <Ionicons
          name="ios-newspaper"
          size={15}
          color="#472DCE"
          style={{ alignSelf: "center" }}
        />
        <Text style={styles.text}>REPORT</Text>
      </TouchableOpacity>}
      {isSuperAdmin && <TouchableOpacity
        onPress={() => navigation.navigate("Version")}
        style={styles.touch}
      >
        <Ionicons
          name="phone-portrait"
          size={15}
          color="#472DCE"
          style={{ alignSelf: "center" }}
        />
        <Text style={styles.text}>VERSION</Text>
      </TouchableOpacity>}

      {isSuperAdmin && <TouchableOpacity
        onPress={() => {
          Linking.openURL("https://backoffice.sosorun.com/map");
        }}
        style={styles.touch}
      >
        <Feather
          name="map-pin"
          size={15}
          color="#472DCE"
          style={{ alignSelf: "center" }}
        />
        <Text style={styles.text}>MAP</Text>
      </TouchableOpacity>}

      {isSuperAdmin && <TouchableOpacity
        onPress={() => navigation.navigate("admins")}
        style={styles.touch}
      >
        <Feather
          name="map-pin"
          size={15}
          color="#472DCE"
          style={{ alignSelf: "center" }}
        />
        <Text style={styles.text}>Admins</Text>
      </TouchableOpacity>}

      <TouchableOpacity
        onPress={() => {
          rmToken();
          setAuth({
            auth: true,
          });
          navigation.navigate("Home");
          navigation.navigate("Login");
        }}
        style={styles.touch}
      >
        <Feather
          name="settings"
          size={15}
          color="#ABABAB"
          style={{ alignSelf: "center" }}
        />
        <Text style={styles.text}>LOG OUT</Text>
      </TouchableOpacity>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    width: width * 0.15,
    height: height,
    backgroundColor: "#fff",
    padding: 10,
  },
  icon: {
    width: 150,
    height: 40,
  },
  text: {
    fontFamily: "Prompt-Regular",
    fontSize: 13,
    marginLeft: 10,
    alignSelf: "center",
  },
  touch: {
    flexDirection: "row",
    height: 40,
  },
});
